import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Inbox, Send, Archive, Trash2, PenSquare } from "lucide-react";
import { MailFolder } from "./types";
import { useMail } from "./use-mail";

interface MailNavProps {
  unreadCount: number;
  onCompose: () => void;
  isCollapsed?: boolean;
}

const folders: { id: MailFolder; label: string; icon: React.ElementType }[] = [
  { id: "inbox", label: "Inbox", icon: Inbox },
  { id: "sent", label: "Sent", icon: Send },
  { id: "archive", label: "Archive", icon: Archive },
  { id: "trash", label: "Trash", icon: Trash2 },
];

export function MailNav({ unreadCount, onCompose, isCollapsed }: MailNavProps) {
  const { selectedFolder, setSelectedFolder, setSelectedMail } = useMail();

  const handleFolderClick = (folder: MailFolder) => {
    setSelectedFolder(folder);
    setSelectedMail(null);
  };

  return (
    <div className="flex flex-col gap-1 p-2">
      <Button
        onClick={onCompose}
        className={cn("mb-2", isCollapsed ? "h-9 w-9 p-0" : "justify-start")}
      >
        <PenSquare className={cn("h-4 w-4", !isCollapsed && "mr-2")} />
        {!isCollapsed && "Compose"}
      </Button>

      {folders.map((folder) => {
        const Icon = folder.icon;
        const isActive = selectedFolder === folder.id;
        const count = folder.id === "inbox" ? unreadCount : 0;

        return (
          <Button
            key={folder.id}
            variant={isActive ? "secondary" : "ghost"}
            className={cn(
              "justify-start",
              isCollapsed && "h-9 w-9 p-0 justify-center"
            )}
            onClick={() => handleFolderClick(folder.id)}
          >
            <Icon className={cn("h-4 w-4", !isCollapsed && "mr-2")} />
            {!isCollapsed && (
              <>
                <span className="flex-1 text-left">{folder.label}</span>
                {count > 0 && (
                  <span className="ml-auto text-xs font-medium text-primary">
                    {count}
                  </span>
                )}
              </>
            )}
          </Button>
        );
      })}
    </div>
  );
}
